var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnYoutube = function SvgBtnYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.445,
    height: 40,
    x: 0.092,
    fill: "red",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M10.5 11h18v18h-18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.405 16.003a2.073 2.073 0 0 0-1.459-1.469c-1.286-.347-6.446-.347-6.446-.347s-5.16 0-6.446.347c-.71.192-1.27.754-1.459 1.469C11.25 17.297 11.25 20 11.25 20s0 2.702.345 3.997c.19.715.75 1.277 1.459 1.469 1.286.346 6.446.346 6.446.346s5.16 0 6.446-.346a2.073 2.073 0 0 0 1.459-1.469c.345-1.295.345-3.997.345-3.997s0-2.702-.345-3.997Zm-9.593 6.45v-4.906L22.125 20l-4.313 2.453Z"
  })));
};
export default SvgBtnYoutube;